var ActivityAddTagModule = /** @class */ (function () {
    function ActivityAddTagModule() {
    }
    return ActivityAddTagModule;
}());
export { ActivityAddTagModule };
